<template>
  <el-tooltip
    effect="dark"
    :placement="placement"
    v-if="overflow"
    :content="content"
  >
    <span class="text" ref="text">
      {{ content }}
    </span>
  </el-tooltip>
  <span class="text" ref="text" v-else>
    {{ content }}
  </span>
</template>

<script>
const placements = [
  'top',
  'top-start',
  'top-end',
  'bottom',
  'bottom-start',
  'bottom-end',
  'left',
  'left-start',
  'left-end',
  'right',
  'right-start',
  'right-end',
]

export default {
  props: {
    placement: {
      type: String,
      default: 'top-start',
      validator(value) {
        return placements.includes(value)
      },
    },

    content: {
      type: String,
      default: ''
    },

    show: {
      type: Boolean,
      default: true,
    }

  },

  data() {
    return {
      overflow: false
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.init()
      }
    },

    content(newVal) {
      this.init()
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      const cWidth = this.$refs.text.clientWidth
      const sWidth = this.$refs.text.scrollWidth
      this.overflow = cWidth < sWidth
    }
  },
}
</script>

<style lang="scss" scoped>
.text {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content {
  word-break: break-all;
}
</style>
